var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlacedBy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 10C4 10.7879 4.15519 11.5681 4.45672 12.2961C4.75825 13.0241 5.20021 13.6855 5.75736 14.2426C6.31451 14.7998 6.97595 15.2417 7.7039 15.5433C8.43185 15.8448 9.21207 16 10 16C10.7879 16 11.5681 15.8448 12.2961 15.5433C13.0241 15.2417 13.6855 14.7998 14.2426 14.2426C14.7998 13.6855 15.2417 13.0241 15.5433 12.2961C15.8448 11.5681 16 10.7879 16 10C16 9.21207 15.8448 8.43185 15.5433 7.7039C15.2417 6.97595 14.7998 6.31451 14.2426 5.75736C13.6855 5.20021 13.0241 4.75825 12.2961 4.45672C11.5681 4.15519 10.7879 4 10 4C9.21207 4 8.43185 4.15519 7.7039 4.45672C6.97595 4.75825 6.31451 5.20021 5.75736 5.75736C5.20021 6.31451 4.75825 6.97595 4.45672 7.7039C4.15519 8.43185 4 9.21207 4 10Z",
    stroke: "#2D3643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.67188C8 9.20231 8.21071 9.71102 8.58579 10.0861C8.96086 10.4612 9.46957 10.6719 10 10.6719C10.5304 10.6719 11.0391 10.4612 11.4142 10.0861C11.7893 9.71102 12 9.20231 12 8.67188C12 8.14144 11.7893 7.63273 11.4142 7.25766C11.0391 6.88259 10.5304 6.67188 10 6.67188C9.46957 6.67188 8.96086 6.88259 8.58579 7.25766C8.21071 7.63273 8 8.14144 8 8.67188Z",
    stroke: "#2D3643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11328 14.5712C6.27829 14.022 6.61593 13.5407 7.07611 13.1985C7.5363 12.8564 8.09451 12.6717 8.66795 12.6719H11.3346C11.9088 12.6717 12.4677 12.8568 12.9282 13.1997C13.3887 13.5427 13.7263 14.0251 13.8906 14.5752",
    stroke: "#2D3643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlacedBy);
export default __webpack_public_path__ + "static/media/placed-by.adf6c5d35d6b8cffe945741d7995c355.svg";
export { ForwardRef as ReactComponent };